import {
  ButtonPrismicAdapter,
  ButtonPrismicAdapterAction,
} from '../button-prismic-adapter/button-prismic-adapter';

type CtaSliceProps = {
  primary: {
    primary_cta: ButtonPrismicAdapterAction;
    primary_cta_label: string;
    secondary_cta: ButtonPrismicAdapterAction;
    secondary_cta_label: string;
  };
};

export function CtaSlice({ primary }: CtaSliceProps): JSX.Element {
  if (!primary) return <></>;

  const { primary_cta, primary_cta_label, secondary_cta, secondary_cta_label } =
    primary;
  const renderSecondaryCta = secondary_cta && secondary_cta_label;

  return (
    <div className="flex w-full flex-col lg:flex-row-reverse lg:justify-center">
      <ButtonPrismicAdapter
        variant="solid"
        buttonType="primary"
        size={{ _: 'fluid', lg: 'large' }}
        action={primary_cta}
        label={primary_cta_label}
      />
      {renderSecondaryCta && (
        <div className="mt-sm lg:mr-sm w-full lg:mt-0 lg:w-min">
          <ButtonPrismicAdapter
            variant="outline"
            buttonType="primary"
            size={{ _: 'fluid', lg: 'large' }}
            action={secondary_cta}
            label={secondary_cta_label}
          />
        </div>
      )}
    </div>
  );
}
